<template>
    <footer class="app-footer">
        <div class="footer">
            <router-link to="/">
                <img class="logo" src="./images/footer_logo.png" alt="AUBE">
            </router-link>
            <p>Copyright© Edu Tek Company Limited All Rights Reserved</p>
        </div>
        <transition name="fade">
            <div v-if="showScrollToTop" :class="['scrollTop', {'bottom': isBottom}]" @click="handleOnClickGoTop()">
                <img src="./images/scrollTop.png" alt="">
            </div>
        </transition>
    </footer>
</template>

<script>

export default {
    name: 'app-footer',

    data() {
        return {
            scrollPosition: false,
            isLogged: true,
        }
    },

    methods: {
        handleScroll() {
            this.scrollPosition = window.scrollY;
        },

        handleOnClickGoTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    },

    computed: {
        isMobileMenu: function() {
            return window.innerWidth <= 991;
        },
        showScrollToTop: function() {
            return this.scrollPosition > 100;
        },
        isBottom: function() {
            return this.isMobileMenu == this.showScrollToTop;
        },
    },

    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

    destroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: all 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
